import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import { UpdateProductTabProps } from '../../../interfaces/Product/UpdateProductTab';
import { sharedStyles } from '../../../utils/Style';
import { UpdateProductMedia } from './UpdateProductMedia';
import { UpdateProductOptionsMedia } from './UpdateProductOptionsMedia';

export const UpdateProductMediaTab = (props: UpdateProductTabProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [optionsView, setOptionsView] = useState(false);

  const goBack = () => navigate(`/products/catalog${location.search}`);

  return (
    <Box sx={{ ...sharedStyles.pageBody, p: 3 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Medya</Typography>

        <Box sx={{ flexGrow: 1 }} />

        <ButtonGroup>
          <Button
            onClick={() => setOptionsView(false)}
            variant={optionsView ? 'outlined' : 'contained'}
            sx={{ ...sharedStyles.buttonText }}
          >
            Ürün
          </Button>
          <Button
            onClick={() => setOptionsView(true)}
            variant={optionsView ? 'contained' : 'outlined'}
            sx={{ ...sharedStyles.buttonText }}
          >
            Varyantlar
          </Button>
        </ButtonGroup>
      </Box>

      {optionsView ? (
        <UpdateProductOptionsMedia {...props} />
      ) : (
        <UpdateProductMedia {...props} />
      )}
    </Box>
  );
};
